import {h, Fragment} from "preact"
import { useAppState, useProductFilters } from "@nosto/preact"
import { useState, useEffect, useRef } from "preact/hooks"

import SearchBanner from "./SearchBanner"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import Skeleton from "./Skeleton"
import NoResults from "./NoResults"

export default function Serp() {
    const { response: { products }, loading } = useAppState();
    const { filters } = useProductFilters();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ expandedFacet, setExpandedFacet ] = useState(null);
    const recRef = useRef(null);

    // useEffect(() => {
    //     if(foundProducts && recRef?.current?.children?.length === 0) {
    //         window.nostojs(api => {
    //             api
    //             .createRecommendationRequest({ includeTagging: true })
    //             .setElements([ "searchpage-nosto-3" ])
    //             .load({ skipPageViews: true, skipEvents: true })
    //         })
    //     }
        
    //     return () => {
    //         if(recRef.current) {
    //             recRef.current.textContent = ''
    //         }    
    //     }
    // }, [ foundProducts ])

    useEffect(() => {
        const bodyEl = document.querySelector('body');
        (sidebarOpen && bodyEl)
            ?   bodyEl.classList.add('overflow-hidden')
            :   bodyEl.classList.remove('overflow-hidden');
    }, [sidebarOpen])

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    return (
        <div className="ns-serp">
            {foundProducts ? (
                <>
                    <Sidebar 
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        expandedFacet={expandedFacet}
                    />
                    <div className="ns-serp-inner">
                        <SearchBanner />
                        <Toolbar 
                            toggleSidebar={toggleSidebar}
                            setExpandedFacet={setExpandedFacet}
                        />
                        <Products /> 
                        <BottomToolbar />
                    </div>
                    {/* <div class="nosto_element" id="searchpage-nosto-3" ref={recRef}></div> */}
                </>
            ) : loading ? (
                <Skeleton />
            ) : (
                <NoResults />
            )}
        </div>
    )
}
